module.exports = __webpack_public_path__ + "img/ai-icon.16138125.svg";